import {
    CURRENCY_TO_LOCALES,
    DEFAULT_INTERNATIONAL_LOCALE,
} from "../constants/locales";

export const getCurrencyLocaleValue = (currencyName: string) => {
    if (CURRENCY_TO_LOCALES[currencyName]) {
        return CURRENCY_TO_LOCALES[currencyName];
    }
    return DEFAULT_INTERNATIONAL_LOCALE;
};
